import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import RightPanel from './rightPanel';
import CenterPanel from './centerPanel';
import CenterPanelOtherUser from './centerPanelOtherUser';
import RightPanelConfirmation from './rightPanelConfirmation';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';
import {
  removeMyRole,
  undoRemoveMyRole,
  undoRemoveAllRole,
  updateMyRoles,
  removeAllMyRole,
  updateOtherUsersRoles,
  updateRolesInOtherNetworks,
  updateSingleUsersForAdmin,
  resetMyRoles,
} from 'actions/user';
import { showMyRolesModal, showOtherUserRolesModal } from 'actions/modal';
import { logout } from 'businessLogic/authorizator';
import { displayGlobalMessage } from 'actions/globalMessage';
import { useDispatch } from 'react-redux';

const MyRolesContent = (props) => {
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState('');
  const [saveIntermediateClick, setSaveIntermediateClick] = useState(false);
  const [confirmSaveClick, setConfirmSaveClick] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [disabledClass, setDisabledClass] = useState('disable');

  useEffect(() => {
    if (props.deletedRoleIds && props.deletedRoleIds.length == 0 && saveIntermediateClick == true) {
      setSaveIntermediateClick(false);
    }
    if (props.deletedRoleIds && props.myRoles && props.deletedRoleIds.length == props.myRoles.length) {
      // Means it's selected all
      setSelectAll(true);
    }
  }, [props.deletedRoleIds, props.myRoles]);

  useEffect(() => {
    return () => {
      dispatch(resetMyRoles());
      dispatch(updateRolesInOtherNetworks(false));
    };
  }, []);

  const handleSearchTerm = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleDeleteRole = (personNetworkRoleId) => {
    setDisabledClass('');
    if (!saveIntermediateClick) {
      dispatch(removeMyRole(personNetworkRoleId));
    }
  };

  const handleUndoDeleteRole = (personNetworkRoleId) => {
    if (props.deletedRoleIds && props.deletedRoleIds.length == 1) {
      setDisabledClass('disable');
    }
    setSelectAll(false);
    dispatch(undoRemoveMyRole(personNetworkRoleId));
  };

  const handleSave = () => {
    if (disabledClass !== 'disable') {
      setSaveIntermediateClick(true);
      setSearchTerm('');
    }
  };

  const handleConfirmSaveForOtherUser = () => {
    // Avoid multiple clicks
    if (confirmSaveClick) {
      return;
    }
    setConfirmSaveClick(true);
    let cb = (successful) => {
      if (successful) {
        dispatch(
          displayGlobalMessage({
            text: APP.LANGUAGE.MyRoles.RemoveSuccessMessage.replace(
              '##UserName##',
              props.selectedUser.firstName + ' ' + props.selectedUser.lastName
            ),
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
        dispatch(updateSingleUsersForAdmin(props.selectedUser.personId));
        setConfirmSaveClick(false);
        cancelUpdateOtherUserRole();
      } else {
        dispatch(
          displayGlobalMessage({
            text: APP.LANGUAGE.MyRoles.FailureSave.replace(
              '##UserName##',
              props.selectedUser.firstName + ' ' + props.selectedUser.lastName
            ),
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
            autoHide: true,
            browserURL: window.location.href,
          })
        );
        setConfirmSaveClick(false);
      }
    };
    dispatch(updateOtherUsersRoles(props.deletedRoleIds, props.selectedUser.personId, cb));
  };

  const handleConfirmSave = () => {
    // Avoid multiple clicks
    if (confirmSaveClick) {
      return;
    }

    setConfirmSaveClick(true);
    let cb = (roles) => {
      if (roles.length > 0) {
        //means there are more roles, so we will display the success message
        dispatch(
          displayGlobalMessage({
            text: APP.LANGUAGE.MyRoles.RemoveSuccessMessage.replace('##UserName##', props.userName),
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
      } else {
        logout(dispatch);
      }
      setConfirmSaveClick(false);
      cancelUpdateMyRole();
    };
    dispatch(updateMyRoles(props.deletedRoleIds, cb));
  };
  const cancelUpdateMyRole = () => {
    setConfirmSaveClick(false);
    dispatch(undoRemoveAllRole());
    dispatch(showMyRolesModal(false));
  };

  const cancelUpdateOtherUserRole = () => {
    setSelectAll(false);
    setSaveIntermediateClick(false);
    dispatch(undoRemoveAllRole());
    dispatch(updateRolesInOtherNetworks(false));
    dispatch(showOtherUserRolesModal(false));
  };

  const cancelConfirmUpdate = () => {
    setSaveIntermediateClick(false);
  };

  const selectAllFunc = (event, data) => {
    if (data.checked == true) {
      // If select all means intending to delete all roles
      dispatch(removeAllMyRole());
      setDisabledClass('');
    } else if (data.checked == false) {
      // If select all means intending to undo delete all roles
      dispatch(undoRemoveAllRole());
    }
    setSelectAll(!selectAll);
  };

  let showModal = props.showMyRolesModal || props.showOtherUsersRolesModal;
  var userName = !!props.isViewingOthers
    ? APP.LANGUAGE.MyRoles.Header.replace(
        '##UserName##',
        props.selectedUser.firstName + ' ' + props.selectedUser.lastName
      )
    : APP.LANGUAGE.MyRoles.Header.replace('##UserName##', props.userName);

  let selectedUserName = !!props.isViewingOthers
    ? props.selectedUser.firstName + ' ' + props.selectedUser.lastName
    : '';

  return (
    <Modal show={showModal} hideWhenClickAway={false} className="ui modal">
      <PopupHeader
        helpLink={
          !!props.isViewingOthers
            ? APP.EXTERNAL_LINKS.ManageAllUsers.HelpUserRoles
            : APP.EXTERNAL_LINKS.MyRoles.HelpAboutMyRoles
        }
        title={userName}
      />
      <div className="content mrtxxs">
        <div className="main-ui-container pdbl">
          <div id="righthandfloatingpanel">
            <div className="right ui rail mrtxs">
              <div className="ui sticky">
                {saveIntermediateClick ? (
                  !!props.isViewingOthers ? (
                    <RightPanelConfirmation
                      myRoles={props.myRoles}
                      deletedRoleIds={props.deletedRoleIds}
                      handleConfirmSave={handleConfirmSaveForOtherUser}
                      cancelConfirmUpdate={cancelConfirmUpdate}
                      confirmSaveClick={confirmSaveClick}
                      isViewingOthers={props.isViewingOthers}
                      hasRolesInOtherNetworks={props.hasRolesInOtherNetworks}
                      selectedUserName={selectedUserName}
                    />
                  ) : (
                    <RightPanelConfirmation
                      myRoles={props.myRoles}
                      deletedRoleIds={props.deletedRoleIds}
                      handleConfirmSave={handleConfirmSave}
                      cancelConfirmUpdate={cancelConfirmUpdate}
                      confirmSaveClick={confirmSaveClick}
                    />
                  )
                ) : !!props.isViewingOthers ? (
                  <RightPanel
                    dispatch={dispatch}
                    handleSave={handleSave}
                    cancelUpdateMyRole={cancelUpdateOtherUserRole}
                    deletedRoleIds={props.deletedRoleIds}
                    isViewingOthers={props.isViewingOthers}
                    selectedUserName={selectedUserName}
                    disabledClass={disabledClass}
                  />
                ) : (
                  <RightPanel
                    dispatch={dispatch}
                    handleSave={handleSave}
                    cancelUpdateMyRole={cancelUpdateMyRole}
                    deletedRoleIds={props.deletedRoleIds}
                    disabledClass={disabledClass}
                  />
                )}
              </div>
            </div>
            {!!props.isViewingOthers ? (
              <CenterPanelOtherUser
                dispatch={dispatch}
                myRoles={props.myRoles}
                searchTerm={searchTerm}
                ifSelectAll={selectAll}
                selectAll={selectAllFunc}
                handleSearchTerm={handleSearchTerm}
                handleDeleteRole={handleDeleteRole}
                handleUndoDeleteRole={handleUndoDeleteRole}
                saveIntermediateClick={saveIntermediateClick}
              />
            ) : (
              <CenterPanel
                dispatch={dispatch}
                myRoles={props.myRoles}
                searchTerm={searchTerm}
                handleSearchTerm={handleSearchTerm}
                handleDeleteRole={handleDeleteRole}
                handleUndoDeleteRole={handleUndoDeleteRole}
                saveIntermediateClick={saveIntermediateClick}
              />
            )}
            <div className="bottom-rail-with-left-and-right-content mrtxl pdts">
              {saveIntermediateClick ? (
                !!props.isViewingOthers ? (
                  <RightPanelConfirmation
                    myRoles={props.myRoles}
                    deletedRoleIds={props.deletedRoleIds}
                    handleConfirmSave={handleConfirmSaveForOtherUser}
                    cancelConfirmUpdate={cancelConfirmUpdate}
                    confirmSaveClick={confirmSaveClick}
                    isViewingOthers={props.isViewingOthers}
                    hasRolesInOtherNetworks={props.hasRolesInOtherNetworks}
                    selectedUserName={selectedUserName}
                  />
                ) : (
                  <RightPanelConfirmation
                    myRoles={props.myRoles}
                    deletedRoleIds={props.deletedRoleIds}
                    handleConfirmSave={handleConfirmSave}
                    cancelConfirmUpdate={cancelConfirmUpdate}
                    confirmSaveClick={confirmSaveClick}
                  />
                )
              ) : !!props.isViewingOthers ? (
                <RightPanel
                  dispatch={dispatch}
                  handleSave={handleSave}
                  cancelUpdateMyRole={cancelUpdateOtherUserRole}
                  deletedRoleIds={props.deletedRoleIds}
                  isViewingOthers={props.isViewingOthers}
                  selectedUserName={selectedUserName}
                  disabledClass={disabledClass}
                />
              ) : (
                <RightPanel
                  dispatch={dispatch}
                  handleSave={handleSave}
                  cancelUpdateMyRole={cancelUpdateMyRole}
                  deletedRoleIds={props.deletedRoleIds}
                  disabledClass={disabledClass}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

MyRolesContent.propTypes = {
  myRoles: PropTypes.array, // Roles selected user has
  deletedRoleIds: PropTypes.array, // Array of role's IDs that tends to delete
  isViewingOthers: PropTypes.bool, // If viewing myRoles or selected user's roles
  hasRolesInOtherNetworks: PropTypes.bool, // Flag to show if selected user has other roles in the platform
};

export default MyRolesContent;
